import React from "react";
import Cart from "../cart";
import Checkout from "../checkout";
import AppDrawer from "../drawer";
import Footer from "../footer";
import Products from "../products";
import SearchBox from "../search";

const Services = () => {
  return (
    <>
      <Products />
      <Footer />
      <AppDrawer />
      <Cart />
      <Checkout />
      <SearchBox />
    </>
  );
};

export default Services;
